import { Box, Typography, Select, MenuItem, FormControl, InputLabel } from '@mui/material'
import type React from 'react'

import type { UnableToVerifyReason } from './constants'
import { UNABLE_TO_VERIFY_REASON_OPTIONS } from './constants'

interface Props {
  selectedReason?: UnableToVerifyReason
  onReasonChange: (reason: UnableToVerifyReason) => void
}

export const ReasonStep: React.FC<Props> = ({ selectedReason, onReasonChange }) => {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
      <Box>
        <Typography variant="h6" fontWeight={600} gutterBottom>
          Why is this income unable to be verified?
        </Typography>
        <Typography variant="body2" color="text.secondary">
          Select the reason that best describes why the applicant has not connected to a
          trusted source. This determines the outcome and available next steps.
        </Typography>
      </Box>

      <FormControl fullWidth>
        <InputLabel id="unable-to-verify-reason-label">Reason</InputLabel>
        <Select
          labelId="unable-to-verify-reason-label"
          id="unable-to-verify-reason-select"
          value={selectedReason ?? ''}
          label="Reason"
          onChange={e => onReasonChange(e.target.value as UnableToVerifyReason)}
          displayEmpty
        >
          {UNABLE_TO_VERIFY_REASON_OPTIONS.map(option => (
            <MenuItem key={option.value} value={option.value}>
              {option.label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  )
}
